import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromReducer from './os-update-states.reducer';
import { OsUpdateStatus, OsUpdateStatusState } from './os-update-states.state';
import { DevicesRouterStoreSelectors } from '../router';

export const selectOsUpdateStatussesState = createFeatureSelector<OsUpdateStatusState>(
  fromReducer.MdmOsUpdateStatesFeatureKey
);

export const selectOsUpdateStatusses = createSelector(
  selectOsUpdateStatussesState,
  fromReducer.selectOsUpdateStatusses
);

export const selectOsUpdateStatussesIds = createSelector(
  selectOsUpdateStatussesState,
  fromReducer.selectOsUpdateStatussesIds
);

export const selectOsUpdateStatussesEntities = createSelector(
  selectOsUpdateStatussesState,
  fromReducer.selectOsUpdateStatussesEntities
);

export const selectOsUpdateStatussesByUdid = createSelector(
  selectOsUpdateStatusses,
  DevicesRouterStoreSelectors.selectUdid,
  (status: OsUpdateStatus[], udid: string) => status.filter((s) => s.udid === udid)
);
